// extracted by mini-css-extract-plugin
export default {"cardWrapper":"poc-detail-card_cardWrapper__KdQqh","Avatar":"poc-detail-card_Avatar__7V5bL","contentWrapper":"poc-detail-card_contentWrapper__1YFnx"};